import { ArtistTourType as ApiArtistTourType } from 'src/api/generated/touring/types';
import { mapLinkableEntityType } from '../../../common';
import { ArtistTourType } from '../../types';

export const mapArtistTourType = (
  apiArtistTour: ApiArtistTourType
): ArtistTourType => {
  return {
    tour: mapLinkableEntityType(apiArtistTour.tour),
    artist: mapLinkableEntityType(apiArtistTour.artist),
    isSupportAct: apiArtistTour.isSupportAct,
    coHeadliner1: apiArtistTour.coHeadliner1
      ? mapLinkableEntityType(apiArtistTour.coHeadliner1)
      : null,
    coHeadliner2: apiArtistTour.coHeadliner2
      ? mapLinkableEntityType(apiArtistTour.coHeadliner2)
      : null,
    status: apiArtistTour.status,
    tourYear: apiArtistTour.tourYear,
    production: apiArtistTour.production,
    configuration: apiArtistTour.configuration,
    showSetup: apiArtistTour.showSetup,
  };
};
